"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.denormalize = exports.parse = void 0;
const linkset_1 = require("./core/linkset");
const link_1 = require("./core/link");
/**
 * Denormalizes a set of links into an instance of a Linkset.
 * {@inheritDoc Linkset.from}
 * {@see {@link NormalizedLinksetInterface}}
 */
function denormalize(normalized) {
    const links = [];
    normalized.linkset.forEach((contextObject) => {
        const { anchor } = contextObject, rels = __rest(contextObject, ["anchor"]);
        Object.keys(rels).forEach((rel) => {
            contextObject[rel].forEach((targetObject) => {
                links.push(new link_1.Link(Object.assign({ anchor, rel }, targetObject)));
            });
        });
    });
    return new linkset_1.Linkset(links);
}
exports.denormalize = denormalize;
/**
 * Parses an application/linkset+json document into a Linkset instance.
 * {@see {@link denormalize}}
 */
function parse(json) {
    return denormalize(JSON.parse(json));
}
exports.parse = parse;
